import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { AdsSessionContextProvider } from './session/AdsSessionContextProvider.js';
import { defaultExperiment as defaultExperimentContext } from './session/Experiment.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var resolveDroneContextFromWindow = function resolveDroneContextFromWindow() {
  var _window, _window2;
  if (((_window = window) === null || _window === void 0 ? void 0 : _window.droneDesignSystemContext) === undefined) {
    // eslint-disable-next-line no-console
    console.error('droneDesignSystemContext is not defined on window');
  }
  var _ref = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.droneDesignSystemContext) || {},
    locale = _ref.locale,
    direction = _ref.direction,
    experiment = _ref.experiment;
  return {
    locale: locale,
    direction: direction,
    experiment: experiment || defaultExperimentContext
  };
};
var AutoDesignSystemContextProvider = /*#__PURE__*/React.memo(function (_ref2) {
  var children = _ref2.children,
    theme = _ref2.theme;
  var windowContext = resolveDroneContextFromWindow();
  var contextWithTheme = _objectSpread(_objectSpread({}, windowContext), {}, {
    theme: theme
  });
  return /*#__PURE__*/React.createElement(AdsSessionContextProvider, {
    value: contextWithTheme
  }, children);
});
AutoDesignSystemContextProvider.displayName = 'AutoDesignSystemContextProvider';

export { AutoDesignSystemContextProvider };
//# sourceMappingURL=AutoDesignSystemContextProvider.js.map
